import { render } from "./AppSorting.vue?vue&type=template&id=c5121f46"
import script from "./AppSorting.vue?vue&type=script&lang=js"
export * from "./AppSorting.vue?vue&type=script&lang=js"

import "./AppSorting.vue?vue&type=style&index=0&id=c5121f46&scope=true&lang=scss"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__